import Cookies from 'js-cookie'
const TokenKey = 'saber-access-token'
const RefreshTokenKey = 'saber-refresh-token'
export function getToken () {
    return Cookies.get(TokenKey)
}

export function setToken (token, timer) {
    return Cookies.set(TokenKey, token, { expires: timer })
}

export function getRefreshToken () {
    return Cookies.get(RefreshTokenKey)
}

export function setRefreshToken (token, timer) {
    return Cookies.set(RefreshTokenKey, token, { expires: timer })
}

export function removeToken () {
    return Cookies.remove(TokenKey)
}

export function removeRefreshToken () {
    return Cookies.remove(RefreshTokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js